module.exports = __webpack_public_path__ + "img/imgBuy_sp.e3a1bc1d.png";